import * as React from 'react';
import { observer } from 'mobx-react';
import { ProductLicenseResource } from '../../../../Types';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { AlreadyTranslated, T } from '../../../../../../Translations';

interface Props {
  productLicense: ProductLicenseResource;
}

const WhoIsItFor: React.FC<Props> = ({ productLicense }) =>
  productLicense.payload.licenseTypeWhoIsItFor
    .map((licenseTypeWhoIsItFor) => (
      <div className="mt-5">
        <h4 className="mb-3 text-sm font-semibold text-[#202532]">
          <T kind="Who is it for?" />
        </h4>
        <p className="text-sm">
          <AlreadyTranslated content={licenseTypeWhoIsItFor} />
        </p>
      </div>
    ))
    .getOrElse(emptyFragment);

export default observer(WhoIsItFor);
